import React from 'react'

import {PageTitle} from '../../components';

import Layout from '../../components/about/Layout';


export default () => (
  <Layout>
    <PageTitle title='专注领域'/>
  </Layout>
)


// WEBPACK FOOTER //
// ./src/pages/about/scopes.js